import React from 'react';
import { Modal } from 'antd';
import moment from 'moment';
import { getOnfleetImageUrls, getOrderCompletionDetails, getOrderCompletionTime, getTrackingInfo } from '../../../utils/onfleetUtils';
import DeliveryImageCarousel from './DeliveryImageCarousel';

export const showOnfleetCompletionModal = (record, { isAdmin = false } = {}) => {
    const completionDetails = getOrderCompletionDetails(record);
    const completionTime = getOrderCompletionTime(record);
    const deliveryImages = getOnfleetImageUrls(completionDetails);
    const { finalTrackingUrl } = getTrackingInfo(record);

    Modal.info({
      title: `Onfleet Completion - Order #${record.id}`,
      width: 700,
      content: (
        <div className="p-2" style={{ overflowWrap: 'anywhere' }}>
          <div className="mb-3">
            <p><strong>Status:</strong> {completionDetails?.success === false ? 'Failed' : (completionDetails ? 'Success' : record.order_status)}</p>
            {completionTime && <p><strong>Completed:</strong> {moment(completionTime).format('DD MMM YYYY, HH:mm')}</p>}
            {record.task_id && <p><strong>Task ID:</strong> {record.task_id}</p>}
            {completionDetails?.notes && <p><strong>Notes:</strong> {completionDetails.notes}</p>}
            {finalTrackingUrl && (
              <p>
                <strong>Tracking:</strong>{' '}
                <a href={finalTrackingUrl} target="_blank" rel="noopener noreferrer">
                  {finalTrackingUrl}
                </a>
              </p>
            )}
          </div>

          {deliveryImages.length > 0 ? (
            <DeliveryImageCarousel images={deliveryImages} maxHeight={360} />
          ) : (
            <p className="text-gray-500">No delivery images are available for this task.</p>
          )}
          {isAdmin && record.driver_name && (
            <details className="mt-3">
              <summary>Delivery Details</summary>
              <p><strong>Driver:</strong> {record.driver_name}</p>
              {record.driver_phone && <p><strong>Contact:</strong> {record.driver_phone}</p>}
            </details>
          )}
        </div>
      ),
      okText: 'Close'
    });
  };
